import { connect } from 'react-redux';
import TopBar from '../layouts/Main/components/TopBar';
import { APP_PATH_EDITOR_JOB } from '../config';
import { withRouter } from 'react-router-dom';
import { draftJobCacheCleared } from '../redux/features/job/jobsSlice';
import { clearDraftCompanySession, clearDraftFileSession } from '../lib/sessionStorage';

const mapStateToProps = (state) => {
  return {
    user: state.users.user
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    onClickPlus: ({ history }) => {
      // Clear all drafts to start fresh when creating a new job
      // This prevents ownership issues and ensures clean slate
      dispatch(draftJobCacheCleared());
      clearDraftCompanySession();
      clearDraftFileSession();
      history.push(APP_PATH_EDITOR_JOB);
    }
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(TopBar));
